<details-section class="knowledge-check-scoring" [title]="'simulationBuilder.KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE' | transloco" [showDetails]="false">
  <!-- Disabled until scoring a Knowledge Check test session is supported. -->
  <button headerAction qai-button [shape]="'normal'" [kind]="'tertiary'" [size]="'medium'" [disabled]="true">
    {{ 'simulationBuilder.SCORE_LAST_SESSION' | transloco }}
  </button>

  <p class="scoring-description">{{ 'simulationBuilder.KNOWLEDGE_CHECK_SCORING_DESCRIPTION' | transloco }}</p>
  <p class="scoring-description">{{ 'simulationBuilder.KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION' | transloco }}</p>

  <div class="rubric-field">
    <qai-field [label]="'simulationBuilder.KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL' | transloco">
      <qai-floating-select
        [shape]="'rectangle'"
        [placeholder]="'simulationBuilder.SELECT_RUBRIC_PLACEHOLDER' | transloco"
        [options]="rubricOptions"
        [allowDeselect]="true"
        [disabled]="readOnly"
        [value]="rubricControl?.value ?? ''"
        (valueChange)="onRubricChange($event)"
      ></qai-floating-select>
    </qai-field>
  </div>
</details-section>
